module.exports = __webpack_public_path__ + "static/media/services.28c1d21.mp4";


//////////////////
// WEBPACK FOOTER
// ./assets/video/services.mp4
// module id = 7npP
// module chunks = 1